import { configureEcho } from '@laravel/echo-vue'

let isConfigured = false

export function initEcho() {
    if (isConfigured) {
        return
    }

    const baseUrl = import.meta.env.VITE_META_BASE_API || 'http://localhost'
    const wsHost = import.meta.env.VITE_REVERB_HOST || 'localhost'
    const wsPort = import.meta.env.VITE_REVERB_PORT || 8081
    const appKey = import.meta.env.VITE_REVERB_APP_KEY || 'fjgwlojqprdhlpjmni5a'

    configureEcho({
        broadcaster: 'reverb',
        key: appKey,
        wsHost: wsHost,
        wsPort: Number(wsPort),
        forceTLS: false,
        enabledTransports: ['ws'],
    })

    isConfigured = true
    console.log('Echo configured.')
}

export function resetEcho() {
    isConfigured = false
}
